import { Channel } from '@at/sauron-platform-core'
import { FacetName } from '../../../__generated__/fed-graphql-types'
import { ChannelSearchTypeKey } from '../../channel-utilities'

// Initial request, rendering, mapping data
export const facetsByChannelSearchEvolution: Map<ChannelSearchTypeKey, FacetName[]> = new Map()

facetsByChannelSearchEvolution.set(Channel.cars, [
    FacetName.acceleration_values,
    // FacetName.additional_adverts,
    FacetName.aggregated_trim,
    FacetName.annual_tax_values,
    FacetName.battery_charge_time_values,
    FacetName.battery_quick_charge_time_values,
    FacetName.battery_range_values,
    FacetName.body_type,
    FacetName.boot_size_values,
    FacetName.category_tag,
    FacetName.co2_emission_values,
    FacetName.colour,
    FacetName.digital_retailing,
    FacetName.distance,
    FacetName.doors_values,
    FacetName.drivetrain,
    FacetName.engine_power,
    FacetName.engine_size,
    FacetName.finance,
    FacetName.fuel_consumption_values,
    FacetName.fuel_type,
    FacetName.insurance_group,
    FacetName.is_manufacturer_approved,
    FacetName.is_writeoff,
    FacetName.keywords,
    FacetName.lat_long,
    FacetName.lease_in_stock,
    FacetName.lease_product_type,
    FacetName.leasing,
    FacetName.lease_monthly_price,
    FacetName.make,
    FacetName.mileage,
    FacetName.model,
    FacetName.monthly_price,
    FacetName.ni_only,
    FacetName.part_exchange_available,
    FacetName.postcode,
    FacetName.price,
    FacetName.price_search_type,
    FacetName.seats_values,
    FacetName.seller_type,
    FacetName.style,
    FacetName.sub_style,
    FacetName.transmission,
    FacetName.ulez_compliant,
    FacetName.engine_power,
    FacetName.with_digital_retailing,
    FacetName.with_manufacturer_rrp_saving,
    FacetName.year_manufactured,
])

facetsByChannelSearchEvolution.set(Channel.cycles, [
    FacetName.postcode,
    FacetName.lat_long,
    FacetName.distance,
    FacetName.make,
    FacetName.model,
    FacetName.style,
    FacetName.frame_size_cm,
    FacetName.price,
    FacetName.colour,
    FacetName.keywords,
])

facetsByChannelSearchEvolution.set(Channel.vans, [
    FacetName.body_type,
    FacetName.cab_type,
    FacetName.co2_emission_values,
    FacetName.colour,
    FacetName.distance,
    FacetName.doors_values,
    FacetName.engine_power,
    FacetName.engine_size,
    FacetName.finance,
    FacetName.fuel_type,
    FacetName.fuel_consumption_values,
    FacetName.is_manufacturer_approved,
    FacetName.is_writeoff,
    FacetName.keywords,
    FacetName.lat_long,
    FacetName.leasing,
    FacetName.lease_monthly_price,
    FacetName.make,
    FacetName.mileage,
    FacetName.model,
    FacetName.monthly_price,
    FacetName.ni_only,
    FacetName.postcode,
    FacetName.price,
    FacetName.price_search_type,
    FacetName.seats_values,
    FacetName.seller_type,
    FacetName.transmission,
    FacetName.vat_status,
    FacetName.wheelbase,
    FacetName.with_digital_retailing,
    FacetName.with_manufacturer_rrp_saving,
    FacetName.year_manufactured,
])

facetsByChannelSearchEvolution.set(Channel.bikes, [
    FacetName.postcode,
    FacetName.lat_long,
    FacetName.distance,
    FacetName.make,
    FacetName.model,
    FacetName.body_type,
    FacetName.price,
    FacetName.monthly_price,
    FacetName.price_search_type,
    FacetName.finance,
    FacetName.engine_size_cc,
    FacetName.engine_power,
    FacetName.year_manufactured,
    FacetName.mileage,
    FacetName.fuel_type,
    FacetName.colour,
    FacetName.licence_type,
    FacetName.seller_type,
    FacetName.keywords,
    FacetName.part_exchange_available,
    FacetName.is_writeoff,
    FacetName.is_manufacturer_approved,
    FacetName.with_manufacturer_rrp_saving,
])
facetsByChannelSearchEvolution.set(Channel.caravans, [
    FacetName.distance,
    FacetName.make,
    FacetName.model,
    FacetName.price,
    FacetName.berth,
    FacetName.year_manufactured,
    FacetName.style,
    FacetName.trailer_axle_number,
    FacetName.bedroom_layout,
    FacetName.end_layout,
    FacetName.mtplm,
    FacetName.exterior_length,
    FacetName.seller_type,
    FacetName.keywords,
])

facetsByChannelSearchEvolution.set(Channel.motorhomes, [
    FacetName.distance,
    FacetName.make,
    FacetName.model,
    FacetName.price,
    FacetName.year_manufactured,
    FacetName.berth,
    FacetName.transmission,
    FacetName.mileage,
    FacetName.exterior_length,
    FacetName.body_type,
    FacetName.fuel_type,
    FacetName.engine_size,
    FacetName.seats,
    FacetName.driver_position,
    FacetName.end_layout,
    FacetName.bedroom_layout,
    FacetName.seller_type,
    FacetName.is_writeoff,
    FacetName.keywords,
])

facetsByChannelSearchEvolution.set(Channel.trucks, [
    FacetName.postcode,
    FacetName.lat_long,
    FacetName.distance,
    FacetName.location,
    FacetName.make,
    FacetName.model,
    FacetName.body_type,
    FacetName.style,
    FacetName.sub_style,
    FacetName.axle_config,
    FacetName.year_manufactured,
    FacetName.price_search_type,
    FacetName.price,
    FacetName.poa,
    FacetName.gross_vehicle_weight,
    FacetName.cab_type,
    FacetName.mileage_km,
    FacetName.engine_power,
    FacetName.transmission,
    FacetName.fuel_type,
    FacetName.emission_class,
    FacetName.driver_position,
    FacetName.keywords,
    FacetName.advertising_location,
])

facetsByChannelSearchEvolution.set(Channel.plant, [
    FacetName.postcode,
    FacetName.lat_long,
    FacetName.distance,
    FacetName.location,
    FacetName.style,
    FacetName.sub_style,
    FacetName.make,
    FacetName.model,
    FacetName.price,
    FacetName.price_search_type,
    FacetName.poa,
    FacetName.year_manufactured,
    FacetName.hours_used,
    FacetName.keywords,
    FacetName.advertising_location,
])

facetsByChannelSearchEvolution.set(Channel.farm, [
    FacetName.postcode,
    FacetName.lat_long,
    FacetName.distance,
    FacetName.location,
    FacetName.style,
    FacetName.sub_style,
    FacetName.make,
    FacetName.model,
    FacetName.price_search_type,
    FacetName.price,
    FacetName.poa,
    FacetName.year_manufactured,
    FacetName.hours_used,
    FacetName.keywords,
    FacetName.advertising_location,
])

facetsByChannelSearchEvolution.set('cars-leasing', [
    FacetName.aggregated_trim,
    FacetName.battery_charge_time_values,
    FacetName.battery_quick_charge_time_values,
    FacetName.battery_range_values,
    FacetName.body_type,
    FacetName.boot_size_values,
    FacetName.engine_size,
    FacetName.fuel_type,
    FacetName.lease_in_stock,
    FacetName.lease_product_type,
    FacetName.leasing,
    FacetName.lease_monthly_price,
    FacetName.lease_monthly_price_ex_vat,
    FacetName.make,
    FacetName.model,
    FacetName.price_search_type,
    FacetName.seats_values,
    FacetName.transmission,
])

facetsByChannelSearchEvolution.set('vans-leasing', [
    FacetName.body_type,
    FacetName.cab_type,
    FacetName.engine_size,
    FacetName.fuel_type,
    FacetName.lease_in_stock,
    FacetName.lease_monthly_price,
    FacetName.lease_monthly_price,
    FacetName.lease_monthly_price_ex_vat,
    FacetName.lease_product_type,
    FacetName.leasing,
    FacetName.make,
    FacetName.model,
    FacetName.price_search_type,
    FacetName.seats_values,
    FacetName.transmission,
    FacetName.wheelbase,
])
